import { SVGProps } from 'react';

const Sun = (props: SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} viewBox="0 0 24 24" fill="none" {...props}>
    <g filter="url(#aSun)">
      <circle cx={12} cy={10} r={6} fill="#FFE86F" />
    </g>
    <defs>
      <filter
        id="aSun"
        width={24}
        height={24}
        x={0}
        y={0}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0.0941176 0 0 0 0 0.0980392 0 0 0 0 0.168627 0 0 0 0.24 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_8753_35060"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_8753_35060"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);
export default Sun;
